export default {
  fu: {
    search_bar: {
      search: '搜索',
      adv_search: '高級搜索',
      ok: '確定',
      cancel: '取消',
      please_select: '請選擇',
      please_input: '請輸入',
      like: '包含',
      not_like: '不包含',
      in: '屬于',
      not_in: '不屬于',
      gt: '大于',
      ge: '大于等于',
      lt: '小于',
      le: '小于等于',
      eq: '等于',
      ne: '不等于',
      between: '之間',
      select_date: '選擇日期',
      start_date: '開始日期',
      end_date: '結束日期',
      select_date_time: '選擇日期時間',
      start_date_time: '開始日期時間',
      end_date_time: '結束日期時間',
      range_separator: '至',
      data_time_error: '開始日期不能大于結束日期',
      clean: '清空',
      refresh: '刷新'
    },
    table: {
      ok: '確定',
      custom_table_fields: '自定義表格字段',
      custom_table_fields_desc: '固定字段不在選擇範圍'
    },
    steps: {
      cancel: '取消',
      next: '下一步',
      prev: '上一步',
      finish: '完成'
    }
  },
  route: {
    dashboard: '首頁',
    documentation: '文檔',
    guide: '引導頁',
    permission: '全縣測試頁',
    rolePermission: '角色權限',
    pagePermission: '頁面權限',
    directivePermission: '指令權限',
    icons: '圖標',
    components: '組件',
    tinymce: '富文本編輯器',
    markdown: 'Markdown',
    jsonEditor: 'JSON 編輯器',
    dndList: '列表拖拽',
    splitPane: 'Splitpane',
    avatarUpload: '頭像上傳',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: '小組件',
    backToTop: '返回頂部',
    dragDialog: '拖拽 Dialog',
    dragSelect: '拖拽 Select',
    dragKanban: '可拖拽看板',
    charts: '圖表',
    keyboardChart: '鍵盤圖表',
    lineChart: '折線圖',
    mixChart: '混合圖表',
    example: '綜合實例',
    nested: '路由嵌套',
    menu1: '菜單1',
    'menu1-1': '菜單 1-1',
    'menu1-2': '菜單 1-2',
    'menu1-2-1': '菜單 1-2-1',
    'menu1-2-2': '菜單 1-2-2',
    'menu1-3': '菜單 1-3',
    menu2: '菜單 2',
    Table: 'Table',
    dynamicTable: '動態 Table',
    dragTable: '拖拽 Table',
    inlineEditTable: 'Table 內編輯',
    complexTable: '綜合 Table',
    tab: 'Tab',
    form: '表單',
    createArticle: '創建文章',
    editArticle: '編輯文章',
    articleList: '文章列表',
    errorPages: '錯誤頁面',
    page401: '401',
    page404: '404',
    errorLog: '錯誤日誌',
    excel: 'Excel',
    exportExcel: '導出 Excel',
    selectExcel: '導出 已選擇項',
    mergeHeader: '導出 多級表頭',
    uploadExcel: '上傳 Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: '換膚',
    clipboardDemo: 'Clipboard',
    i18n: '國際化',
    externalLink: '外鏈',
    profile: '個人中心'
  },
  navbar: {
    dashboard: '首頁',
    github: '項目地址',
    logOut: '退出登陸',
    profile: '個人中心',
    theme: '換膚',
    size: '佈局大小'
  },
  login: {
    title: '系統登陸',
    welcome: '歡迎使用',
    logIn: '登陸',
    username: '帳號',
    password: '密碼',
    any: '任意字符',
    thirdparty: '第三方登陸',
    thirdpartyTips: '本地不能模擬，請結合自己業務進行模擬！！！',
    expires: '登陸信息過期，請重新登陸',
    tokenError: '信息錯誤，請重新登陸',
    username_error: '請輸入正確的 ID',
    password_error: '密碼不小於 8 位'
  },
  commons: {
    switch_lang: '切換語言成功',
    close: '關閉',
    icon: '圖標',
    all: '全部',
    enable: '啟用',
    disable: '禁用',
    yes: '是',
    no: '否',
    reset: '重置',
    catalogue: '目錄',
    button: '按鈕',
    gender: '性別',
    man: '男',
    woman: '女',
    nick_name: '姓名',
    confirmPassword: '確認密碼',
    upload: '上傳',
    cover: '覆蓋',
    not_cover: '不覆蓋',
    import_mode: '導入模式',
    import_module: '導入模塊',
    please_fill_in_the_template: '請填寫模板內容',
    cut_back_old_version: '切匯舊版',
    cut_back_new_version: '切匯新版',
    comment: '評論',
    examples: '示例',
    help_documentation: '幫助文檔',
    api_help_documentation: 'API文檔',
    delete_cancelled: '已取消刪除',
    workspace: '工作空開你',
    organization: '組織',
    menu: '菜單',
    setting: '設置',
    project: '項目',
    about_us: '關於',
    current_project: '當前項目',
    name: '名稱',
    description: '描述',
    annotation: '註釋',
    clear: '清空',
    save: '保存',
    update: '更新',
    save_success: '保存成功',
    delete_success: '刪除成功',
    copy_success: '複製成功',
    modify_success: '修改成功',
    delete_cancel: '已取消刪除',
    confirm: '確定',
    cancel: '取消',
    prompt: '提示',
    operating: '操作',
    input_limit: '長度在 {0} 到 {1} 個字符',
    login: '登陸',
    welcome: '一站式開源數據分析平臺',
    username: '姓名',
    password: '密碼',
    input_username: '請輸入用戶姓名',
    input_password: '請輸入密碼',
    test: '測試',
    create_time: '創建時間',
    update_time: '更新時間',
    add: '添加',
    member: '成員',
    email: '郵箱',
    phone: '電話',
    role: '角色',
    personal_info: '個人信息',
    api_keys: 'API Keys',
    quota: '配額管理',
    status: '狀態',
    show_all: '顯示全部',
    show: '顯示',
    report: '報告',
    user: '用戶',
    system: '系統',
    personal_setting: '個人設置',
    test_resource_pool: '測試資源池',
    system_setting: '系統設置',
    input_content: '請輸入內容',
    create: '新建',
    edit: '編輯',
    copy: '複製',
    refresh: '刷新',
    remark: '備註',
    delete: '刪除',
    reduction: '恢復',
    not_filled: '未填寫',
    please_select: '請選擇',
    search_by_name: '根據名稱搜索',
    personal_information: '個人信息',
    exit_system: '退出系統',
    verification: '驗證',
    title: '標題',
    custom: '自動義',
    select_date: '選擇日期',
    months_1: '一月',
    months_2: '二月',
    months_3: '三月',
    months_4: '四月',
    months_5: '五月',
    months_6: '六月',
    months_7: '七月',
    months_8: '八月',
    months_9: '九月',
    months_10: '十月',
    months_11: '十一月',
    months_12: '十二月',
    weeks_0: '周日',
    weeks_1: '周一',
    weeks_2: '周二',
    weeks_3: '周三',
    weeks_4: '周四',
    weeks_5: '周五',
    weeks_6: '周六',
    system_parameter_setting: '系統參數設置',
    connection_successful: '連接成功',
    connection_failed: '連接失敗',
    save_failed: '保存失敗',
    host_cannot_be_empty: '主機不能為空',
    port_cannot_be_empty: '端口號不能為空',
    account_cannot_be_empty: '帳戶不能為空',
    remove: '移除',
    remove_cancel: '移除取消',
    remove_success: '移除成功',
    tips: '認證信息已過期，請重新登陸',
    not_performed_yet: '尚未執行',
    incorrect_input: '輸入內容不正確',
    delete_confirm: '請輸入以下內容，確認刪除：',
    login_username: 'ID 或 郵箱',
    input_login_username: '請輸入用戶 ID 或 郵箱',
    input_name: '請輸入名稱',
    please_upload: '請上傳文件',
    please_fill_path: '請填寫url 路徑',
    formatErr: '格式錯誤',
    please_save: '請先保存',
    reference_documentation: '參考文檔',
    id: 'ID',
    millisecond: '毫秒',
    cannot_be_null: '不能為空',
    required: '{0}是必填的',
    already_exists: '名稱不能重複',
    modifier: '修改人',
    validate: '校驗',
    batch_add: '批量添加',
    tag_tip: '輸入回車添加標簽',
    table: {
      select_tip: '已選中 {0} 條數據'
    },
    date: {
      select_date: '選擇日期',
      start_date: '開始日期',
      end_date: '結束日期',
      select_date_time: '選擇日期時間',
      start_date_time: '開始日期時間',
      end_date_time: '結束日期時間',
      range_separator: '至',
      data_time_error: '開始日期不能大與結束日期'
    },
    adv_search: {
      title: '高級搜索',
      combine: '組合查詢',
      test: '所屬測試',
      project: '所屬項目',
      search: '查詢',
      reset: '重置',
      and: '所有',
      or: '任意一個',
      operators: {
        is_empty: '空',
        is_not_empty: '非空',
        like: '包含',
        not_like: '不包含',
        in: '屬與',
        not_in: '不屬與',
        gt: '大與',
        ge: '大與等與',
        lt: '小與',
        le: '小與等與',
        equals: '等與',
        not_equals: '不等與',
        between: '之間',
        current_user: '是當前用戶'
      },
      message_box: {
        alert: '警告',
        confirm: '確認'
      }
    },
    monitor: '監控',
    image: '鏡像',
    tag: '標簽',
    module: {
      select_module: '選擇模塊',
      default_module: '默認模塊'
    },
    datasource: '數據源',
    char_can_not_more_50: '不能超過50字符',
    share_success: '分享成功',
    input_id: '請輸入ID',
    input_pwd: '請輸入密碼',
    message_box: {
      alert: '警告',
      confirm: '確認'
    }
  },
  documentation: {
    documentation: '文檔',
    github: 'Github 地址'
  },
  permission: {
    addRole: '新增角色',
    editPermission: '編輯權限',
    roles: '你的權限',
    switchRoles: '切換權限',
    tips: '在某些情況下，不適合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它動態渲染 dom 的場景。你只能通過手動設置 v-if 來實現。',
    delete: '刪除',
    confirm: '確定',
    cancel: '取消'
  },
  guide: {
    description: '引導頁對與一些第一次進入項目的人很有用，你可以簡單介紹下項目的功能。本 Demo 是基與',
    button: '打開引導'
  },
  components: {
    documentation: '文檔',
    tinymceTips: '富文本是管理後臺一個核心的功能，但同時又是一個有很多坑的地方。在選擇富文本的過程中我也走了不少的彎路，市面上常見的富文本都基本用過了，最終權衡了一下選擇了Tinymce。更詳細的富文本比較和介紹見',
    dropzoneTips: '由與我司業務有特殊需求，而且要傳七牛 所以沒用第三方，選擇了自己封裝。代碼非常的簡單，具體代碼你可以在這裏看到 @/components/Dropzone',
    stickyTips: '當頁面滾動到預設的位置會吸附在頂部',
    backToTopTips1: '頁面滾動到指定位置會在右下角出現返回頂部按鈕',
    backToTopTips2: '可自定義按鈕的樣式、show/hide、出現的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
    imageUploadTips: '由與我在使用時它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的話，優先還是使用官方版本。'
  },
  table: {
    dynamicTips1: '固定標頭，按照表頭順序排序',
    dynamicTips2: '不固定標頭, 按照點擊順序排序',
    dragTips1: '默認排序',
    dragTips2: '拖拽後排序',
    title: '標題',
    importance: '重要性',
    type: '類型',
    remark: '點評',
    search: '搜索',
    add: '添加',
    export: '導出',
    reviewer: '審核人',
    id: '序號',
    date: '時間',
    author: '作者',
    readings: '閱讀數',
    status: '狀態',
    actions: '操作',
    edit: '編輯',
    publish: '發布',
    draft: '草稿',
    delete: '刪除',
    cancel: '取消',
    confirm: '確定'
  },
  example: {
    warning: '創建和編輯頁面是不能被 keep-alive 緩存的，因為keep-alive 的 include 目前不支持根據路由來緩存，所以目前都是基與 component name 來進行緩存的。如果你想類似的實現緩存效果，可以使用 localStorage 等瀏覽器緩存方案。或者不要使用 keep-alive 的 include，直接緩存所有頁面。詳情見'
  },
  errorLog: {
    tips: '請點擊右上角bug小圖標',
    description: '現在的管理後臺基本都是spa的形式了，它增強了用戶體驗，但同時也會增加頁面出問題的可能性，可能一個小小的疏忽就導致整個頁面的死鎖。好在 Vue 官網提供了一個方法來捕獲處理異常，你可以在其中進行錯誤處理或者異常上報。',
    documentation: '文檔介紹'
  },
  excel: {
    export: '導出',
    selectedExport: '導出已選擇項',
    placeholder: '請輸入文件名(默認excel-list)'
  },
  zip: {
    export: '導出',
    placeholder: '請輸入文件名(默認file)'
  },
  pdf: {
    tips: '這裏使用 window.print() 來實現下載pdf的功能'
  },
  theme: {
    change: '換膚',
    documentation: '換膚文檔',
    tips: 'Tips: 它區別於 navbar 上的 theme-pick, 是兩種不同的換膚方法，各自有不同的應用場景，具體請參考文檔。'
  },
  tagsView: {
    refresh: '刷新',
    close: '關閉',
    closeOthers: '關閉其他',
    closeAll: '關閉所有'
  },
  settings: {
    title: '系統佈局配置',
    theme: '主題色',
    tagsView: '開啟 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '側邊欄 Logo'
  },
  license: {
    i18n_no_license_record: '沒有 License 紀錄',
    i18n_license_is_empty: 'License 為空',
    title: '授權管理',
    corporation: '客戶名稱',
    time: '授權時間',
    product: '產品名稱',
    edition: '產品版本',
    licenseVersion: '授權版本',
    count: '授權數量',
    valid_license: '授權驗證',
    show_license: '查看授權',
    valid_license_error: '授權驗證失敗',
    status: '授權狀態',
    valid: '有效',
    invalid: '無效',
    expired: '已過期'
  },
  member: {
    create: '添加成員',
    modify: '修改成員',
    delete_confirm: '這個用戶確定要刪除嗎?',
    please_choose_member: '請選擇成員',
    search_by_name: '根據名稱搜索',
    modify_personal_info: '修改個人信息',
    edit_password: '修改密碼',
    edit_information: '編輯信息',
    input_name: '請輸入名稱',
    input_email: '請輸入郵箱',
    special_characters_are_not_supported: '不支持特殊字符',
    mobile_number_format_is_incorrect: '手機號碼格式不正確',
    email_format_is_incorrect: '郵箱格式不正確',
    password_format_is_incorrect: '有效密碼：8-30位，英文大小寫字母+數字+特殊字符（可選）',
    old_password: '舊密碼',
    new_password: '新密碼',
    repeat_password: '確認密碼',
    inconsistent_passwords: '兩次輸入的密碼不一致',
    remove_member: '確定要移除該成員嗎',
    org_remove_member: '確定要移除該成員嗎？',
    input_id_or_email: '請輸入用戶 ID, 或者 用戶郵箱',
    no_such_user: '無此用戶信息, 請輸入正確的用戶 ID 或者 用戶郵箱！'
  },
  user: {
    create: '新建用戶',
    modify: '修改用戶',
    input_name: '請輸入用戶姓名',
    input_id: '請輸入ID',
    input_email: '請輸入郵箱',
    input_password: '請輸入密碼',
    input_phone: '請輸入電話號碼',
    input_roles: '請選擇角色',
    special_characters_are_not_supported: '不支持特殊字符',
    mobile_number_format_is_incorrect: '手機號碼格式不正確',
    email_format_is_incorrect: '郵箱格式不正確',
    delete_confirm: '這個用戶確定要刪除嗎?',
    apikey_delete_confirm: '這個 API Key 確定要刪除嗎?',
    input_id_placeholder: '請輸入ID (不支持中文)',
    source: '用戶來源',
    choose_org: '選擇組織',
    reset_password: '重置密碼',
    current_user: '當前用戶',
    origin_passwd: '原始密碼',
    new_passwd: '新密碼',
    confirm_passwd: '確認密碼',
    change_password: '修改密碼',
    search_by_name: '按姓名搜索'
  },
  role: {
    menu_authorization: '菜單授權',
    data_authorization: '數據授權',
    please_choose_role: '請選擇角色',
    admin: '系統管理員',
    org_admin: '組織管理員',
    org_member: '組織成員',
    add: '新建角色',
    delete: '刪除角色',
    modify: '修改角色',
    tips: '提示',
    confirm_delete: '確認刪除角色 ',
    role_name: '角色名稱',
    search_by_name: '按名稱搜索',
    pls_input_name: '請輸入名稱'
  },
  menu: {
    parent_category: '上級目錄',
    module_name: '組件名稱',
    module_path: '組件路徑',
    route_addr: '路由地址',
    menu_sort: '菜單排序',
    authority_identification: '權限標識',
    button_name: '按鈕名稱',
    select_icon: '選擇圖標',
    create_time: '創建日期',
    tile: '菜單標題',
    create: '創建菜單',
    modify: '修改菜單',
    delete: '刪除菜單',
    delete_confirm: '確定刪除菜單嗎？',
    menu_type: '菜單類型'
  },
  organization: {
    parent_org: '上級組織',
    select_parent_org: '選擇上級組織',
    top_org: '頂級組織',
    name: '組織名稱',
    sort: '組織排序',
    sub_organizations: '下屬組織數',
    create_time: '創建日期',
    create: '新建組織',
    modify: '修改組織',
    delete: '刪除組織',
    delete_confirm: '刪除該組織會關聯刪除該組織的下屬組織，確定要刪除嗎?',
    input_name: '請輸入組織名稱',
    select_organization: '請選擇組織',
    search_by_name: '根據名稱搜索',
    special_characters_are_not_supported: '格式錯誤(不支持特殊字符，且不能以\'-\'開頭結尾)',
    select: '選擇組織'
  },
  system_parameter_setting: {
    mailbox_service_settings: '郵件設置',
    test_connection: '測試鏈接',
    SMTP_host: 'SMTP主機',
    SMTP_port: 'SMTP端口',
    SMTP_account: 'SMTP帳號',
    SMTP_password: 'SMTP密碼',
    SSL: '開啟SSL(如果SMTP端口是465，通常需要啟用SSL)',
    TLS: '開啟TLS(如果SMTP端口是587，通常需要啟用TLS)',
    SMTP: '是否免密 SMTP',
    host: '主機不能為空',
    port: '端口號不能為空',
    account: '帳戶不能為空',
    test_recipients: '測試收件人',
    tip: ' 提示: 僅用來作為測試郵件收件人'
  },
  chart: {
    save_snapshot: '保存縮略圖',
    datalist: '視圖',
    add_group: '添加分組',
    add_scene: '添加場景',
    group: '分組',
    scene: '場景',
    delete: '刪除',
    move_to: '移動到',
    rename: '重命名',
    tips: '提示',
    confirm_delete: '確認刪除',
    delete_success: '刪除成功',
    confirm: '確認',
    cancel: '取消',
    search: '搜索',
    back: '返回',
    add_table: '添加數據集',
    process: '進度',
    add_chart: '添加視圖',
    db_data: '數據庫數據集',
    sql_data: 'SQL數據集',
    excel_data: 'Excel數據集',
    custom_data: '自定義數據集',
    pls_slc_tbl_left: '請從左側選擇視圖',
    add_db_table: '添加數據庫表',
    pls_slc_data_source: '請選擇數據源',
    table: '表',
    edit: '編輯',
    create_view: '創建視圖',
    data_preview: '數據預覽',
    dimension: '緯度',
    quota: '指標',
    title: '標題',
    show: '顯示',
    chart_type: '圖表類型',
    shape_attr: '圖形屬性',
    module_style: '組件樣式',
    result_filter: '結果過濾器',
    x_axis: '橫軸',
    y_axis: '縱軸',
    chart: '視圖',
    close: '關閉',
    summary: '匯總方式',
    fast_calc: '快速計算',
    sum: '求和',
    count: '記數',
    avg: '平均',
    max: '最大值',
    min: '最小值',
    stddev_pop: '標準差',
    var_pop: '方差',
    quick_calc: '快速計算',
    show_name_set: '顯示名設置',
    color: '顏色',
    color_case: '配色方案',
    pls_slc_color_case: '請選餓配色方案',
    color_default: '默認',
    color_retro: '復古',
    color_future: '未來',
    color_gradual: '漸變',
    color_business: '商務',
    color_gentle: '柔和',
    color_elegant: '淡雅',
    color_technology: '科技',
    color_simple: '簡潔',
    not_alpha: '不透明度',
    size: '大小',
    bar_width: '柱寬',
    bar_gap: '柱間隔',
    adapt: '自適應',
    line_width: '線寬',
    line_type: '線型',
    line_symbol: '折點',
    line_symbol_size: '折點大小',
    line_type_solid: '實現',
    line_type_dashed: '虛線',
    line_symbol_circle: '圓形',
    line_symbol_emptyCircle: '空心圓',
    line_symbol_rect: '矩形',
    line_symbol_roundRect: '圓角矩形',
    line_symbol_triangle: '三角形',
    line_symbol_diamond: '菱形',
    line_symbol_pin: '釘子',
    line_symbol_arrow: '箭頭',
    line_symbol_none: '無',
    line_area: '面積',
    pie_inner_radius: '內經',
    pie_outer_radius: '外經',
    funnel_width: '寬度',
    line_smooth: '平滑折線',
    title_style: '標題格式',
    text_fontsize: '字體大小',
    text_color: '字體顏色',
    text_h_position: '水平位置',
    text_v_position: '垂直位置',
    text_pos_left: '左',
    text_pos_center: '中',
    text_pos_right: '右',
    text_pos_top: '上',
    text_pos_bottom: '下',
    text_italic: '字體傾斜',
    italic: '傾斜',
    orient: '方向',
    horizontal: '水平',
    vertical: '垂直',
    legend: '圖例',
    shape: '形狀',
    polygon: '多邊形',
    circle: '圖形',
    label: '標籤',
    label_position: '標籤位置',
    content_formatter: '內容格式',
    inside: '內',
    tooltip: '提示',
    tooltip_item: '數據項',
    tooltip_axis: '座標軸',
    formatter_plc: '內痛格式為空時，顯示默認格式',
    xAxis: '橫洲',
    yAxis: '縱軸',
    position: '位置',
    rotate: '角度',
    name: '名稱',
    icon: '國際',
    trigger_position: '觸發位置',
    asc: '昇序',
    desc: '降序',
    sort: '排序',
    filter: '過濾',
    none: '無',
    background: '背景',
    alpha: '透明度',
    add_filter: '添加過濾',
    no_limit: '無顯示',
    filter_eq: '等於',
    filter_not_eq: '不等於',
    filter_lt: '小於',
    filter_le: '小於等於',
    filter_gt: '大於',
    filter_ge: '大於等於',
    filter_null: '為空',
    filter_not_null: '不為空',
    filter_include: '包含',
    filter_not_include: '不包含',
    rose_type: '玫瑰圖模式',
    radius_mode: '半徑',
    area_mode: '面積',
    rose_radius: '園角',
    view_name: '視圖標題',
    belong_group: '所属分组',
    select_group: '选择分组',
    name_can_not_empty: '名稱不能為空',
    template_can_not_empty: '請選擇儀表板',
    custom_count: '記錄數',
    table_title_fontsize: '表頭字體大小',
    table_item_fontsize: '表格字體大小',
    table_header_bg: '表頭背景',
    table_item_bg: '表格背景',
    table_item_font_color: '字體顏色',
    stripe: '斑馬紋',
    start_angle: '起始角度',
    end_angle: '結束角度',
    style_priority: '樣式優先級',
    dashboard: '儀表板',
    dimension_color: '名稱顏色',
    quota_color: '值顏色',
    dimension_font_size: '名稱字體大小',
    quota_font_size: '值字體大小',
    space_split: '名稱/值間隔',
    only_one_quota: '僅支持1個指標',
    only_one_result: '僅顯示第1個計算結果',
    dimension_show: '名稱顯示',
    quota_show: '值顯示',
    title_limit: '標題不能大於50個字符',
    filter_condition: '過濾條件',
    filter_field_can_null: '過濾字段必填',
    preview_100_data: '預覽前100條記錄',
    chart_table_normal: '明細表',
    chart_card: '指標卡',
    chart_bar: '基礎柱狀圖',
    chart_bar_stack: '堆疊柱狀圖',
    chart_bar_horizontal: '橫向柱狀圖',
    chart_bar_stack_horizontal: '橫向堆疊柱狀圖',
    chart_line: '基礎折線圖',
    chart_line_stack: '堆疊折線圖',
    chart_pie: '餅圖',
    chart_pie_rose: '南丁格爾玫瑰圖',
    chart_funnel: '漏鬥圖',
    chart_radar: '雷達圖',
    chart_gauge: '儀表盤',
    dateStyle: '日期顯示',
    datePattern: '日期格式',
    y: '年',
    y_M: '年月',
    y_M_d: '年月日',
    H_m_s: '時分秒',
    y_M_d_H_m: '年月日時分',
    y_M_d_H_m_s: '年月日時分秒',
    date_sub: 'yyyy-MM-dd',
    date_split: 'yyyy/MM/dd',
    chartName: '新建視圖',
    chart_show_error: '無法正常顯示',
    chart_error_tips: '如有疑問請聯系管理員',
    title_cannot_empty: '標題不能為空',
    table_title_height: '表頭行高',
    table_item_height: '表格行高',
    axis_show: '軸線顯示',
    axis_color: '軸線顏色',
    axis_width: '軸線寬度',
    axis_type: '軸線類型',
    axis_type_solid: '實線',
    axis_type_dashed: '虛線',
    axis_type_dotted: '點',
    axis_label_show: '標簽顯示',
    axis_label_color: '標簽顏色',
    axis_label_fontsize: '標簽大小',
    text_style: '字體樣式',
    bolder: '加粗',
    change_ds: '更換數據集',
    change_ds_tip: '提示：更換數據集將導致字段發生變化，需重新製作視圖',
    axis_name_color: '名稱顏色',
    axis_name_fontsize: '名稱字體',
    pie_label_line_show: '引導線',
    outside: '外',
    center: '中心',
    split: '軸線',
    axis_line: '軸線',
    axis_label: '軸標簽',
    label_fontsize: '標簽大小',
    split_line: '分割線',
    split_color: '分割顏色',
    shadow: '陰影',
    condition: '過濾值',
    filter_value_can_null: '過濾值不能為空',
    filter_like: '包含',
    filter_not_like: '不包含'
  },
  dataset: {
    sheet_warn: '有多個sheet頁面，默認抽取第一個',
    datalist: '數據集',
    add_group: '添加分組',
    add_scene: '添加場景',
    group: '分組',
    scene: '場景',
    delete: '刪除',
    move_to: '移動到',
    rename: '重命名',
    tips: '提示',
    confirm_delete: '確認刪除',
    delete_success: '刪除成功',
    confirm: '確認',
    cancel: '取消',
    search: '搜索',
    back: '返回',
    add_table: '添加數據集',
    process: '進度',
    update: '更新',
    db_data: '數據庫數據集',
    sql_data: 'SQL 數據集',
    excel_data: 'Excel 數據集',
    custom_data: '自定義數據集',
    pls_slc_tbl_left: '請從左側選擇表',
    add_db_table: '添加數據庫數據集',
    pls_slc_data_source: '請選擇數據源',
    table: '表',
    edit: '編輯',
    create_view: '創建視圖',
    data_preview: '數據預覽',
    field_type: '字段類型',
    field_name: '字段名',
    field_origin_name: '原始名',
    field_check: '選中',
    update_info: '更新信息',
    join_view: '數據關聯',
    text: '文本',
    time: '時間',
    value: '數值',
    mode: '模式',
    direct_connect: '直鏈',
    sync_data: '定時同步',
    update_setting: '更新設置',
    sync_now: '立即更新',
    add_task: '添加任務',
    task_name: '任務名稱',
    start_time: '開始時間',
    end_time: '結束時間',
    status: '狀態',
    error: '錯誤',
    completed: '完成',
    underway: '執行中',
    task_update: '更新設置',
    update_type: '更新方式',
    all_scope: '全量更新',
    add_scope: '增量更新',
    select_data_time: '選擇日期時間',
    execute_rate: '執行頻率',
    execute_once: '立即執行',
    cron_config: '表達時設定',
    no_limit: '無限製',
    set_end_time: '設定結束時間',
    operate: '操作',
    save_success: '保存成功',
    close: '關閉',
    required: '必填',
    input_content: '請輸入內容',
    add_sql_table: '添加 SQL 數據集',
    preview: '預覽',
    pls_input_name: '請輸入名稱',
    connect_mode: '鏈接模式',
    incremental_update_type: '增量更新方式',
    incremental_add: '增量添加',
    incremental_delete: '增量刪除',
    last_update_time: '上次更新時間',
    current_update_time: '當前更新時間',
    param: '參數',
    edit_sql: '編輯 SQL 數據集',
    showRow: '顯示行',
    add_excel_table: ' 添加 Excel 數據集',
    add_custom_table: '添加自定義數據集',
    upload_file: '上傳文件',
    detail: '詳情',
    type: '類型',
    create_by: '創建者',
    create_time: '創建時間',
    preview_show: '顯示',
    preview_item: '條數據',
    preview_total: '共',
    pls_input_less_6: '請輸入6位以內的正整數',
    field_edit: '編輯字段',
    table_already_add_to: '該表已添加至',
    uploading: '上傳中...',
    add_union: '新建關聯',
    union_setting: '關聯設置',
    pls_slc_union_field: '請選擇關聯字段',
    pls_slc_union_table: '請選擇關聯表',
    source_table: '關聯表',
    source_field: '關聯字段',
    target_table: '被關聯表',
    target_field: '被關聯字段',
    union_relation: '關聯關係',
    pls_setting_union_success: '請正確設置關聯關係',
    invalid_dataset: ' Kettle 未運行，無效數據集',
    check_all: '銓選',
    can_not_union_self: '被關聯表不能與關聯表相同',
    float: '小數',
    edit_custom_table: '編輯自助數據集',
    edit_field: '編輯自斷',
    preview_100_data: '顯示前100行數據',
    invalid_table_check: '非直連數據集請先完成數據同步',
    parse_error: 'Excel解析失敗，請檢查格式、字段等信息。具體參考：https://dataease.io/docs/faq/dataset_faq/',
    origin_field_type: '原始類型',
    edit_excel_table: '編輯Excel數據集',
    edit_excel: '編輯Excel',
    excel_replace: '替換',
    excel_add: '追加',
    dataset_group: '數據集分組',
    m1: '將 ',
    m2: ' 移動到',
    char_can_not_more_50: '數據集名稱不能超過50個字符',
    task_add_title: '添加任務',
    task_edit_title: '編輯任務'
  },
  datasource: {
    datasource: '數據源',
    please_select_left: '請從左側選擇數據源',
    show_info: '數據源信息',
    create: '新建數據源',
    type: '類型',
    please_choose_type: '請選擇數據源類型',
    data_base: '數據庫名稱',
    user_name: '用戶名',
    password: '密碼',
    host: '主機名/IP地址',
    port: '端口',
    please_input_data_base: '請輸入數據庫名稱',
    please_input_user_name: '請輸入用戶名',
    please_input_password: '請輸入密碼',
    please_input_host: '請輸入主機',
    please_input_port: '請輸入',
    modify: '編輯數據源',
    validate_success: '校驗成功',
    validate: '校驗',
    search_by_name: '根據名稱搜索',
    delete_warning: '確認刪除？',
    input_name: '請輸入名稱',
    input_limit_2_25: '2-25字符',
    input_limit_0_50: '0-50字符',
    oracle_connection_type: '服務名/SID',
    oracle_sid: 'SID',
    oracle_service_name: '服務名',
    get_schema: '獲取 Schema',
    schema: '數據庫 Schema',
    please_choose_schema: '請選擇數據庫 Schema'
  },
  pblink: {
    key_pwd: '請輸入密碼打開鏈接',
    input_placeholder: '請輸入4位數字密碼',
    pwd_error: '密碼錯誤',
    pwd_format_error: '請輸入4位數字密碼',
    sure_bt: '確定'
  },
  panel: {
    no_auth_role: '未分享角色',
    auth_role: '已分享角色',
    picture_limit: '只能插入圖片',
    drag_here: '請將左側字段拖至此處',
    copy_link_passwd: '複製鏈接及密碼',
    copy_link: '複製鏈接',
    passwd_protect: '密碼保護',
    link: '鏈接',
    link_share: '鏈接分享',
    link_share_desc: '開啟鏈接後，任何人可通過此鏈接訪問儀表板。',
    share: '分享',
    datalist: '視圖列表',
    group: '目錄',
    panel: '儀表板',
    panel_list: '儀表板',
    groupAdd: '新建目錄',
    panelAdd: '新建儀表板',
    delete: '刪除',
    move_to: '移動到',
    rename: '重命名',
    import: '導入模板',
    tips: '提示',
    confirm_delete: '確認刪除',
    delete_success: '刪除成功',
    confirm: '確認',
    cancel: '取消',
    search: '搜索',
    back: '返回',
    view: '視圖',
    module: '組件',
    filter_module: '過濾組件',
    select_by_module: '安組件選擇',
    edit: '編輯',
    sys_template: '系統模板',
    user_template: '用戶模板',
    add_category: '添加分類',
    filter_keywords: '輸入關鍵字進行過濾',
    dashboard_theme: '儀表板主題',
    table: '表格',
    gap: '有間隙',
    no_gap: '無間隙',
    component_gap: '組件間隙',
    photo: '圖片',
    default_panel: '默認儀表板',
    create_public_links: '創建公共鏈接',
    to_default: '另存為默認',
    to_default_panel: '另存為默認儀表板',
    store: '收藏',
    save_to_panel: '保存為模板',
    export_to_panel: '導出為模板',
    preview: '預覽',
    fullscreen_preview: '全屏預覽',
    new_tab_preview: '新Tab頁預覽',
    select_panel_from_left: '請從左側選擇儀表板',
    template_nale: '模板名稱',
    template: '模板',
    category: '分類',
    all_org: '所有組織',
    custom: '自定義',
    import_template: '導入模板',
    copy_template: '復用模板',
    upload_template: '上傳模板',
    belong_to_category: '所屬類別',
    pls_select_belong_to_category: '請選擇所屬類別',
    template_name_cannot_be_empty: '模板名稱不能為空',
    select_by_table: '列表選擇',
    data_list: '數據列表',
    component_list: '組件列表',
    custom_scope: '自定義控製範圍',
    multiple_choice: '多選',
    single_choice: '單選',
    field: '字段',
    unshared_people: '未分享人員',
    shared_people: '已分享人員',
    error_data: '獲取數據出錯，請聯繫管理員',
    canvas_size: '畫布大小',
    canvas_scale: '畫布比例',
    style: '樣式',
    clean_canvas: '清空畫布',
    insert_picture: '插入圖片',
    redo: '重做',
    undo: '撤銷',
    panelNull: '這是個空的儀表板，可以通過編輯來豐富內容',
    copy: '復製',
    paste: '粘貼',
    cut: '剪切',
    lock: '鎖定',
    topComponent: '置於頂層',
    bottomComponent: '置於底層',
    upComponent: '上移一層',
    downComponent: '下移一層',
    open_aided_design: '打開組件輔助設計',
    close_aided_design: '關閉組件輔助設計',
    open_style_design: '打開樣式設計',
    close_style_design: '關閉樣式設計',
    matrix_design: '矩陣設計',
    left: 'x 坐標',
    top: 'y 坐標',
    height: '高',
    width: '寬',
    color: '顏色',
    backgroundColor: '背景色',
    borderStyle: '邊框風格',
    borderWidth: '邊框寬度',
    borderColor: '邊框顏色',
    borderRadius: '邊框半徑',
    fontSize: '字體大小',
    fontWeight: '字體粗細',
    lineHeight: '行高',
    letterSpacing: '字間距',
    textAlign: '左右對齊',
    opacity: '透明度',
    verticalAlign: '上下對齊',
    text_align_left: '左對齊',
    text_align_center: '左右居中',
    text_align_right: '右對齊',
    vertical_align_top: '上對齊',
    vertical_align_middle: '居中對齊',
    vertical_align_bottom: '下對齊',
    border_style_solid: '實線',
    border_style_dashed: '虛線',
    select_component: '請選擇組件',
    other_module: '其他',
    content: '內容',
    default_panel_name: '默認儀表板名稱',
    source_panel_name: '原儀表板名稱',
    content_style: '內容樣式',
    canvas_self_adaption: '自適應畫布區域'
  },
  plugin: {
    local_install: '本地安裝',
    remote_install: '遠程安裝',
    name: '插件名稱',
    free: '是否免費',
    cost: '費用',
    descript: '描述',
    version: '版本',
    creator: '作者',
    install_time: '安裝時間',
    release_time: '時間',
    un_install: '卸載',
    uninstall_confirm: '確定卸載該插件',
    uninstall_cancel: '取消卸載插件'
  },
  display: {
    logo: '頭部系統 Logo',
    loginLogo: '登陸頁面頭部 Logo',
    loginImage: '登陸頁面右側圖片',
    loginTitle: '登陸頁面標題',
    title: '系統名稱',
    advice_size: '建議圖片大小'
  },
  auth: {
    authConfig: '權限配置',
    authQuickConfig: '權限快捷配置',
    dept: '組織',
    role: '角色',
    user: '用戶',
    linkAuth: '數據源權限',
    datasetAuth: '數據集權限',
    chartAuth: '視圖權限',
    panelAuth: '儀表板權限',
    menuAuth: '菜單和操作權限',
    deptHead: '所有組織',
    roleHead: '所有角色',
    userHead: '所有用戶',
    linkAuthHead: '所有數據源',
    datasetAuthHead: '所有數據集',
    chartAuthHead: '所有視圖',
    panelAuthHead: '所有儀表板',
    view: '查看',
    use: '使用',
    export: '導出',
    manage: '管理'
  },
  about: {
    auth_to: '授權給',
    invalid_license: 'License 無效',
    update_license: '更新 License',
    expiration_time: '過期時間',
    expirationed: '(已過期)',
    auth_num: '授權數量',
    version: '版本',
    version_num: '版本號',
    standard: '標準版',
    enterprise: '企業版',
    suport: '獲取技術支持',
    update_success: '更新成功'
  },
  template: {
    exit_same_template_check: '當前存在相同名稱模板，是否覆蓋？',
    override: '覆蓋',
    cancel: '取消',
    confirm_upload: '上傳確認'
  },
  cron: {
    second: '秒',
    minute: '分',
    hour: '時',
    day: '日',
    month: '月',
    week: '周',
    year: '年',
    d_w_cant_not_set: '日期與星期不可以同時為“不指定”',
    d_w_must_one_set: '日期與星期必須有一個為“不指定”',
    every_day: '每日',
    cycle: '周期',
    not_set: '不指定',
    from: '從',
    to: '至',
    repeat: '循環',
    day_begin: '日開始，每',
    day_exec: '日執行一次',
    work_day: '工作日',
    this_month: '本月',
    day_near_work_day: '號，最近的工作日',
    this_week_last_day: '本月最後一天',
    set: '指定',
    every_hour: '每時',
    hour_begin: '時開始，每',
    hour_exec: '時執行一次',
    every_month: '每月',
    month_begin: '月開始，每',
    month_exec: '月執行一次',
    every: '每',
    every_begin: '開始，每',
    every_exec: '執行一次',
    every_week: '每周',
    week_start: '從星期',
    week_end: '至星期',
    every_year: '每年',
    week_tips: '說明：1-7 分別對應 周日-周六'
  },
  dept: {
    can_not_move_change_sort: '不能移動以改變排序',
    can_not_move_parent_to_children: '父組織不能移動到自己的子節點下',
    move_success: '移動成功'
  },
  webmsg: {
    web_msg: '站內消息通知',
    show_more: '查看更多',
    all_type: '全部類型',
    panel_type: '儀表板分享',
    dataset_type: '數據集同步',
    content: '消息內容',
    sned_time: '提交時間',
    read_time: '查看時間',
    type: '類型',
    mark_readed: '標記已讀',
    please_select: '請至少選擇一條消息',
    mark_success: '標記已讀成功'
  }
}
